export const css = {
    root: 'Z4rG-Tkh',
    clear: '_2j20g31E',
    player: '_5omo6gfO',
    playlist: 'T9ems35T',
    playlistTitle: 'GvIdH7W0',
    playlistItem: 'Lnz-9mSN',
    topicAudio: 'WEnZXjzS',
    ' _key': 'audio/audio'
};
export default css;
